module.exports = __webpack_public_path__ + "static/photo11@2x-c87eae86d62d27ae48b1c8d4353ea201.png";